import * as React from 'react'
import styled from 'styled-components'

import type { IVisit } from '@app/domain/visit/visit.interface'

import { VisitRowComponent } from './visit-row'

const VisitListWrapper = styled.div`
  display: table;
  border-collapse: collapse;
  width: 100%;
`

const VisitListRowWrapper = styled.div`
  display: table-row;
  border-bottom: 1px solid lightgrey;
`

export enum VisitListVariant {
  HidePatient = 'no_patient',
}

interface Props {
  onStartIntake: (visit: IVisit) => void
  variant?: VisitListVariant
  visits: Array<IVisit>
}

export const VisitListTable = ({ onStartIntake, variant, visits }: Props) => {
  return (
    <VisitListWrapper>
      {visits.map((visit, index) => {
        return (
          <VisitListRowWrapper key={visit.id}>
            <VisitRowComponent
              visit={visit}
              variant={variant}
              onStartIntake={onStartIntake}
              key={index}
            />
          </VisitListRowWrapper>
        )
      })}
    </VisitListWrapper>
  )
}
